export class RoomConnection {
  constructor(
    public isConnected?: boolean,
    public isAudioProvided?: boolean,
    public isVideoProvided?: boolean
  ) {}
}
